import { render } from "./groupDetail.vue?vue&type=template&id=2bcb82e9&scoped=true&ts=true"
import script from "./groupDetail.vue?vue&type=script&lang=ts&config=true"
export * from "./groupDetail.vue?vue&type=script&lang=ts&config=true"

import "./groupDetail.vue?vue&type=style&index=0&id=2bcb82e9&lang=css"
import "./groupDetail.vue?vue&type=style&index=1&id=2bcb82e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcb82e9"]])

export default __exports__